export const postMessageToReact = (data) => {
    if (!window.ReactNativeWebView) return;
    window.ReactNativeWebView.postMessage(data);
}
